'use client';

import type {
	ButtonProps, HTMLChakraProps, RecipeVariantProps,
} from '@chakra-ui/react';
import { Button, createSlotRecipeContext } from '@chakra-ui/react';

import { NextLinkButton } from '../../next';
import { formSectionSlotRecipe } from '../../theme/slot-recipes/form-section.slot-recipe';

const { withContext, withProvider } = createSlotRecipeContext({ recipe: formSectionSlotRecipe });

type FormSectionRootProps = HTMLChakraProps<'div', RecipeVariantProps<typeof formSectionSlotRecipe>>;
const Root = withProvider<HTMLDivElement, FormSectionRootProps>('div', 'root');

type FormSectionHeaderProps = HTMLChakraProps<'div'>;
const Header = withContext<HTMLDivElement, FormSectionHeaderProps>('div', 'header');

type FormSectionTitleProps = HTMLChakraProps<'h3'>;
const Title = withContext<HTMLHeadingElement, FormSectionTitleProps>('h3', 'title');

type FormSectionBodyProps = HTMLChakraProps<'div'>;
const Body = withContext<HTMLDivElement, FormSectionBodyProps>('div', 'body');

type FormSectionRowProps = HTMLChakraProps<'div'>;
const Row = withContext<HTMLDivElement, FormSectionRowProps>('div', 'row');

type FormSectionDescriptionProps = HTMLChakraProps<'p'>;
const Description = withContext<HTMLParagraphElement, FormSectionDescriptionProps>('p', 'description');

type FormSectionColumnProps = HTMLChakraProps<'div'>;
const Column = withContext<HTMLDivElement, FormSectionColumnProps>('div', 'column');

type FormSectionFieldProps = HTMLChakraProps<'div'>;
const Field = withContext<HTMLDivElement, FormSectionFieldProps>('div', 'field');

type FormSectionFooterProps = HTMLChakraProps<'div'>;
const Footer = withContext<HTMLDivElement, FormSectionFooterProps>('div', 'footer');

const ActionButton = (props: ButtonProps) => {
	return <Button {...props} />;
};

export const FormSection = {
	ActionButton,
	Body,
	Column,
	Description,
	Field,
	Footer,
	Header,
	LinkButton: NextLinkButton,
	Root,
	Row,
	Title,
};
